import { render, staticRenderFns } from "./SelectBoilerplate.vue?vue&type=template&id=57c80868&scoped=true&lang=pug"
import script from "./SelectBoilerplate.vue?vue&type=script&lang=js"
export * from "./SelectBoilerplate.vue?vue&type=script&lang=js"
import style0 from "./SelectBoilerplate.vue?vue&type=style&index=0&id=57c80868&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c80868",
  null
  
)

export default component.exports